import { useEffect } from 'react';
import { environment } from 'services/environment/Environment';
import { useGetAppVersion } from 'services/info';
// import { useStateStorage } from 'store/state';
import { IChildrenProp } from 'types/components/components.interface';

const AppInfoProvider = ({ children }: IChildrenProp) => {
  //   const { version, setVersion } = useStateStorage();
  const { node, api } = environment();

  const apiVersion = useGetAppVersion();

  useEffect(() => {
    console.log('ENV version', api.apiVersion);
    // console.log('Store version', version);
    // if (api.apiVersion !== version) {
    //   warningToast('toast-message.require-new-version', {
    //     version: api.apiVersion,
    //   });
    // }
    // setVersion(api.apiVersion);
  }, [api.apiVersion]);

  return (
    <>
      {children}
      <div className='flex gap-2 absolute bottom-0 right-2 text-[10.5px] opacity-50 hover:opacity-100 transition-all'>
        <p>
          <b>API</b> {apiVersion.data ?? '...'}
        </p>
        <p>
          <b>WEB</b> {environment().api.apiVersion ?? '...'}
        </p>
      </div>
    </>
  );
};

export default AppInfoProvider;
